import { render, staticRenderFns } from "./date-picker-2.vue?vue&type=template&id=55dcfcf0"
import script from "./date-picker-2.vue?vue&type=script&lang=js"
export * from "./date-picker-2.vue?vue&type=script&lang=js"
import style0 from "./date-picker-2.vue?vue&type=style&index=0&id=55dcfcf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports